module.exports = {
  url: '/proxy'
}
